module.exports = {
  url: '/proxy'
}
